import React from "react";
import TableSelector from "../../../components/tables/TableSelector";
import verwvnw from "../../../components/tables/verw-vnw";

const data = [
  {
    les: "40",
    table: verwvnw
  }
];

export default () => (
  <TableSelector
    defaultChapter="40"
    data={data}
    title="Verwijzend voornaamwoord"
  />
);



// WEBPACK FOOTER //
// ./src/pages/spqr/rijtjes/verwijzend-voornaamwoord.js